import React from 'react'
import { Link } from 'react-router-dom'
import doctor from '../assets/doctor.jpg'
import games from '../assets/games.jpg'
import todo from '../assets/todo1.jpg'
import music from '../assets/music.jpg'
import ActionAreaCard from '../components/Card'

const Refreshmentpage = () => {
  return (
    <div className='flex justify-center bg-gradient-to-r from-cyan-200 to-blue-200 h-full'>
        <div className='grid grid-cols-2 gap-4 mt-10 p-2'>
        <a href='https://www.miniclip.com/games/en/'><ActionAreaCard name={"Games for you!Feel fun"} src={games} description={"nil"} /></a>
        <a href='https://www.spotify.com/in-en/'><ActionAreaCard name={"Listen Music!Heal your mind"} src={music} description={"nil"}/></a>
        <Link to='/task-schedular'><ActionAreaCard name={"Divide your work and move On!"} src={todo} description={"nil"}/></Link>
        <Link to='/find_counsellor'><ActionAreaCard name={"Share your problem with counsellor"} src={doctor}  description={"nil"}/></Link>

    </div>

    </div>
  )
}

export default Refreshmentpage